<template lang="html">
  <transition name="move">
    <div class="food" v-show="showFlag" ref="food">
      <div class="food-content">
        <div class="image-header">
          <img :src="food.image" alt="">
          <div class="back" @click="hide">
            <i class="icon icon-arrow_lift"></i>
          </div>
        </div>
        <div class="content">
          <h1 class="title">{{food.name}}</h1>
          <div class="detail">
            <span class="sell-count">{{ $t("sellcount") }}{{food.sellCount}}</span>
            <span class="rating">{{ $t("rating") }}{{food.rating}}%</span>
          </div>
          <div class="price">
            <span class="now">{{food.price}} €</span>
            <span class="old" v-show="food.oldPrice">{{food.oldPrice}} €</span>
          </div>
          <div class="cartcontrol-wrapper">
            <cartcontrol :food="food"  @cartAdd="addFood"></cartcontrol>
          </div>
          <transition name="fade">
            <div class="buy" v-show="!food.count" @click.stop.prevent="addFirst($event)">
              {{ $t("addtocart") }}
            </div>
          </transition>
        </div>
        <split v-show="food.info"></split>
        <div class="info" v-show="food.info">
          <h1 class="title">{{ $t("productinfo") }}</h1>
          <p class="text">{{food.info}}</p>
        </div>
        <split></split>    
      </div>
    </div>
  </transition>
</template>

<script>
import BScroll from 'better-scroll'
import cartcontrol from 'components/cartcontrol/cartcontrol.vue'
import split from 'components/split/split.vue'

export default {
  props: {
    food: {  // food由父组件传入
      type: Object
    }
  },
  data() {
    return {
      showFlag: false  // 默认food组件是隐藏的
    }
  },
  methods: {
    show() {
      this.showFlag = true  // 展示food组件
        /* 初始化要传给ratingselect组件的参数，
        因为data里的数据会被多次复用 */
      this.$nextTick(() => {
        if (!this.scroll) {
          this.scroll = new BScroll(this.$refs.food, {
            click: true
          })
        } else {
          this.scroll.refresh()
            /* refresh() 强制 scroll 重新计算，当 better-scroll 中的元素
            发生变化的时候调用此方法，这样就不需要重新new一个新的better-scroll了
            文档查看"https://github.com/ustbhuangyi/better-scroll" */
        }
      })
    },
    hide() {
      this.showFlag = false // 隐藏food组件
    },
    addFirst(event) {
      if (!event._constructed) {
        return
      }
      this.$emit('cartAdd', event.target)
        // cartcontrol组件发射的事件通过food组件发射add事件给goods
      this.$set(this.food, 'count', 1)
        /* $set是Vue.set的别名，添加原本没有的属性，需要用$set方法
        触发视图的响应，文档见"https://cn.vuejs.org/v2/api/#vm-set",
        $set 方法作用和 Vue.set 一样，但可以不需要 import 引入 Vue */
    },
    addFood() {
      this.$emit('cartAdd', event.target)
    }
  },
  components: {
    cartcontrol,
    split
  },
  filters: {
  },
  updated() {
  }
}
</script>

<style lang="scss">
@import '../../common/sass/mixin.scss';

.food {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 46px;
  z-index: 10;
  width: 100%;
  background: #fff;
  &.move-enter-active, &.move-leave-active { // 动画过程
    transition: all .5s;
    transform: translate3d(0,0,0);
  }
  &.move-enter, &.move-leave-to { // 动画初始态
    transform: translate3d(100%,0,0);
  }
  .image-header {
    position: relative;
    width: 100px;
    padding-top: 100%; // padding计算是相当于父元素的width计算的
    img {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
    }
    .back {
      position: absolute;
      top: 10px;
      left: 5px;
      text-align: center;
      .icon {
        display: inline-block;
        padding: 10px;
        color: #fff;
        font-size: 16px;
        width: 16px;
        height: 16px;
        line-height: 16px;
        background: rgba(227,217,227,0.3);
        border-radius: 50%;
      }
    }
  }
  .content {
    position: relative;
    padding: 18px;
    .title {
      line-height: 14px;
      margin-bottom: 8px;
      font-size: 14px;
      font-weight: 700;
      color: rgb(7,17,27);
    }
    .detail {
      margin-bottom: 18px;
      line-height: 10px;
      height: 10px;
      font-size: 0;
      .sell-count,
      .rating {
        font-size: 10px;
        color: rgb(147,153,159);
      }
      .sell-count {
        margin-right: 12px;
      }
    }
    .price {
        font-weight: 700;
        line-height: 24px;
        font-size: 0;
        .now {
            margin-right: 8px;
            font-size: 14px;
            color: rgb(255,0,0);
        }
        .old {
            font-size: 10px;
            color: rgb(147,153,159);
            text-decoration: line-through;
        }
    }
    .cartcontrol-wrapper {
      position: absolute;
      right: 12px;
      bottom: 12px;
    }
    .buy {
      position: absolute;
      right: 18px;
      bottom: 18px;
      z-index: 10;
      height: 24px;
      line-height: 24px;
      padding: 0 12px;
      box-sizing: border-box;
      font-size: 10px;
      border-radius: 12px;
      color: #fff;
      background: rgb(0,160,220);
      &.fade-enter-active, &.fade-leave-active { // 动画过程
        transition: all .5s;
      }
      &.fade-enter, &.fade-leave-to { // 动画初始态
        opacity: 0;
      }
    }
  }
  .info {
    padding: 18px;
    .title {
      line-height: 14px;
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 6px;
      color: rgb(7,17,27);
    }
    .text {
      line-height: 24px;
      font-size: 12px;
      font-weight: 400;
      padding: 0 8px;
      text-align: justify;
      color: rgb(77,85,93);
    }
  }
  .rating {
    padding-top: 18px;
    .title {
      line-height: 14px;
      margin-left: 18px;
      font-size: 14px;
      color: rgb(7,17,27);
    }
    .rating-wrapper {
      padding: 0 18px;
      .rating-item {
        position: relative;
        padding: 16px 0;
        @include border-1px(rgba(7,17,27,0.1));
        .user {
          position: absolute;
          right: 0;
          top: 16px;
          line-height: 12px;
          font-size: 0;
          color: rgb(147,153,159);
          .name {
            display: inline-block;
            margin-right: 6px;
            vertical-align: top;
            font-size: 10px;
          }
          .avatar {
            border-radius: 50%;
          }
        }
        .time {
          margin-bottom: 6px;
          line-height: 12px;
          font-size: 10px;
          color: rgb(147,153,159);
        }
        .text {
          line-height: 16px;
          font-size: 12px;
          color: rgb(7,17,27);
          .icon {
            margin-right: 4px;
            line-height: 16px;
            font-size: 12px;
            &.icon-thumb_up {
              color: rgb(0,160,220);
            }
            &.icon-thumb_down {
              color: rgb(147,153,159);
            }
          }
        }
      }
      .no-rating {
        padding: 16px 0;
        font-size: 12px;
        color: rgb(147,153,159);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// food.vue?7a3fc164